import { useQuery } from '@tanstack/react-query';
import { COMMUNITY_TEMPLATE_BY_TEMPLATE_ID } from '../../contracts';
import { getTemplateDetails } from '../api/community';

/**
 * `onTemplateViewed` fires INSIDE the queryFn, after the fetch resolves and
 * before the data is returned — the exact position the analytics dispatch
 * occupied pre-move. That ordering is deliberate and load-bearing: the event
 * carries `data.template_id`, so it cannot move to `onSuccess` without either
 * re-deriving the id or firing on cache hits that never fetched.
 */
export function useQueryCommunityTemplateByTemplateUrlPath(
  urlPath: string,
  onTemplateViewed?: (templateId: string) => void
) {
  return useQuery({
    queryKey: [COMMUNITY_TEMPLATE_BY_TEMPLATE_ID, { urlPath }],

    queryFn: async () => {
      const { data } = await getTemplateDetails(urlPath);
      onTemplateViewed?.(data.template_id);
      return data;
    },

    enabled: !!urlPath,
  });
}
